
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const ConfigurationHeader = () => {


    const { pathname } = useLocation();
    const { user } = useSelector((state) => state.auth);
    const { attributes: { enablePodcast } } = user;

    return <div className="d-flex">
        <div className="section_sub_heading">
            <Link className={pathname === "/admin/dashboard/configure/basic" ? "active" : ""} to="/admin/dashboard/configure/basic">Basic</Link>
        </div>
        <div className="section_sub_heading">
            <Link className={pathname === "/admin/dashboard/configure/audio" ? "active" : ""} to="/admin/dashboard/configure/audio">Audio</Link>
        </div>
        <div className={`section_sub_heading ${!enablePodcast ? 'is-faded' : ''}`}>
            <Link className={pathname === "/admin/dashboard/configure/podcast" ? "active" : ""} to="/admin/dashboard/configure/podcast">Podcast</Link>
        </div>
        <div className="section_sub_heading">
            <Link className={pathname === "/admin/dashboard/configure/social" ? "active" : ""} to="/admin/dashboard/configure/social">Social</Link>
        </div>
    </div>;

}

export default ConfigurationHeader;